import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { Button, ButtonColor, RenderType } from '@jsmdg/yoshi';
import { trackNewsLetterSubscription } from '../../helper/trackingFooter';
import { type FooterContext } from '../../types';
import styles from './Newsletter.module.scss';

const messages = defineMessages({
    subscribe: { defaultMessage: 'Abonnieren' },
    subscribeHint: { defaultMessage: 'Newsletter abonnieren und {discountValue} Rabatt sichern' },
});

const NEWSLETTER_SUBSCRIBE_ORIGIN = 'Footer';

const Newsletter = (): JSX.Element => {
    const intl = useIntl();
    const { isTrustpilotEnabled, tenantConfig }: FooterContext = useFragmentContext();

    const subscribeText = intl.formatMessage(messages.subscribe);
    const newsletterSubscribeUrl = `${tenantConfig.urls.newsletter}?source=${NEWSLETTER_SUBSCRIBE_ORIGIN}&label=${NEWSLETTER_SUBSCRIBE_ORIGIN}`;

    const handleClick = (e: React.MouseEvent): void => {
        e.preventDefault();
        trackNewsLetterSubscription(newsletterSubscribeUrl);
        window.location.href = newsletterSubscribeUrl;
    };

    return (
        <div
            className={classNames(
                styles.newsletterBox,
                'px-3x px-sm-6x py-2x py-sm-4x d-sm-flex justify-content-sm-center align-items-sm-center text-center',
                {
                    'mt-3x': !isTrustpilotEnabled,
                },
            )}
            data-testid="newsletterBox"
        >
            <p className="p-0 mr-sm-4x mb-2x mb-sm-0 font-complementary fst-normal fw-semibold">
                {intl.formatMessage(messages.subscribeHint, {
                    discountValue: tenantConfig.newsletter.discount,
                })}
            </p>
            <Button
                as={RenderType.Link}
                href={newsletterSubscribeUrl}
                className="border-0"
                color={ButtonColor.Highlight}
                onClick={handleClick}
                internal
                a11yText={subscribeText}
            >
                {subscribeText}
            </Button>
        </div>
    );
};

export { Newsletter };
